// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nBZF","colMin":"styles_colMin__YtpRE"};